import React from 'react';
import BaseTabs from '@material-ui/core/Tabs';
import BaseTab from '@material-ui/core/Tab';
import styled from 'react-emotion';
import { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const Tabs = styled((props) => (
  <BaseTabs {...props} classes={{ indicator: 'indicator' }} />
))`
  & .indicator {
    background-color: ${colors.purple};
    min-width: 40px;
  }
`;

export const Tab = styled((props) => (
  <BaseTab {...props} classes={{ selected: 'selected', wrapper: 'wrapper' }} />
))`
  display: flex;
  flex: 1;
  text-transform: none;
  font-weight: normal;
  padding: 0px;
  height: 40px;
  min-width: 40px;
  min-height: 0px;
  font-size: 14px;
  &.selected {
    color: ${colors.purple};
  }
  & > span.wrapper > span {
    padding-left: 12px;
    padding-right: 12px;
  }
`;

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  width: 304px;
  overflow-x: hidden;
`;

export const TimeContainer = styled('div')`
  margin-bottom: 4px;
`;
